import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewPeriodicCheckOutDto,
  EditPeriodicCheckOutDto,
  DeletePeriodicCheckOutDto,
  GetOnePeriodicCheckOutDto,
  GetAllPeriodicsChecksOutDto,
  PeriodicCheckDto,
  GetPeriodicsChecksMetricsOutDto,
  GetLastPeriodicCheckOutDto,
  GetCustomerCurrentYearPeriodicChecksOutDto,
} from '../types/periodic-check.dto'

const path = '/control'

class PeriodicCheck {
  public async new(payload: NewPeriodicCheckOutDto<any>) {
    // if (payload?.signer?.signature && !(payload?.signer?.signature as MediaDto)?.key) {
    //   const file = payload?.signer?.signature as File
    //   payload.signer.signature = await services.media.upload(file) as MediaDto
    // }

    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async edit({ idPeriodicCheck, body }: EditPeriodicCheckOutDto<any>) {
    return action
      .Patch({
        url: `${path}/${idPeriodicCheck}`,
        body,
      })
      .then(async response => {
        const updatedResponse = { ...response };

        // // Handle signer.signature if it exists
        // if (response?.signer?.signature) {
        //   const { key, mimeType } = response?.signer?.signature as MediaDto;
        //   const url = await services.media.download({ key, mimeType });
        //   updatedResponse.signer.signature = { ...response?.signer?.signature, ...url };
        // }

        // // Handle auditor.signature if it exists
        // if (response?.['technical-responsible'] && response?.['technical-responsible']?.signature) {
        //   const { key, mimeType } = response?.['technical-responsible']?.signature as MediaDto;
        //   const url = await services.media.download({ key, mimeType });
        //   updatedResponse['technical-responsible'].signature = { ...response?.['technical-responsible']?.signature, ...url };
        // }

        return { response: updatedResponse };
      })
      .catch(error => {
        return { error }
      })
  }

  public async getAll({ filters, pagination, sort, group }: GetAllPeriodicsChecksOutDto) {
    const filtersJSON = filters && Object.keys(filters).length > 0 ? `&filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/paginated/${paginationString({ pagination, sort, group })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getCustomerCurrentYearPeriodicChecks({ idCustomer, year }: GetCustomerCurrentYearPeriodicChecksOutDto) {
    const yearParam = year ? `?year=${year}` : '';
    return action
      .Get({
        url: `${path}/customer/${idCustomer}${yearParam}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getOne({ idPeriodicCheck }: GetOnePeriodicCheckOutDto<any>) {
    return action
      .Get({
        url: `${path}/${idPeriodicCheck}`,
      })
      .then(async (response: PeriodicCheckDto<any>) => {
        const updatedResponse = { ...response };

        return { response: updatedResponse };
      })
      .catch(error => {
        return { error }
      })
  }

  public async getLast(data: GetLastPeriodicCheckOutDto) {
    return action
      .Get({
        url: `${path}/get-last?idCustomer=${data?.idCustomer}&type=${data?.type}&date=${data?.date}`,
      })
      .then(async (response: PeriodicCheckDto<any>) => {
        const updatedResponse = { ...response };

        return { response: updatedResponse };
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idPeriodicCheck }: DeletePeriodicCheckOutDto) {
    return action
      .Get({
        url: `${path}/${idPeriodicCheck}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getMetrics({ filters }: GetPeriodicsChecksMetricsOutDto) {
    const filtersJSON = filters ? `?filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/metrics${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  /**
   * Function to get a file URL for download.
   * @param {Object} params - The parameters for getting the file URL.
   * @param {string} params.fileName - The name of the file to be retrieved.
   * @returns {Promise<Object>} - The URL to the file or an error.
   */
  async deleteMedia({ idPeriodicCheck, fieldName, idMedia }): Promise<{ url: string }> {
    return action
      .Del({
        url: `${path}/${idPeriodicCheck}/delete-media`,
        body: {
          fieldName,
          idMedia
        }
      })
      .then(response => {
        return response
      })
      .catch(error => {
        console.error(error)
        return ''
      })
  }
}

const periodicCheck = new PeriodicCheck()
export default periodicCheck
